import React, { createContext, useContext, useLayoutEffect } from 'react';

type SetFullScreen = (isFullScreen: boolean) => void;

const FullScreenLayoutContext = createContext<SetFullScreen>(() => {});

type FullScreenLayoutProviderProps = {
	onFullScreenChange: SetFullScreen;
	children: React.ReactNode;
};

export function FullScreenLayoutProvider({
	onFullScreenChange,
	children,
}: FullScreenLayoutProviderProps) {
	return (
		<FullScreenLayoutContext.Provider value={onFullScreenChange}>
			{children}
		</FullScreenLayoutContext.Provider>
	);
}

/**
 * Lays the dashboard out like a full-screen route (no TopBar or MobileNav)
 * while the calling component is mounted, for steps that share a route with
 * screens that keep them.
 */
export function useFullScreenLayout() {
	const setFullScreen = useContext(FullScreenLayoutContext);
	// Layout effect so the nav is gone before the first paint of the caller.
	useLayoutEffect(() => {
		setFullScreen(true);
		return () => setFullScreen(false);
	}, [setFullScreen]);
}
